export { CopyIcon } from './copy'
